import { AuthAPI, getIpGeoLocation } from '@cibo/core'
import { Position } from 'geojson'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEY } from './queryKey'

export const useIPGeolocation = () => {
  return useQuery<Position>(
    [QUERY_KEY.IP_GEOLOCATION],
    async () => {
      let ipGeoLocation = getIpGeoLocation()
      if (!ipGeoLocation) {
        await AuthAPI.authCheck()
        ipGeoLocation = getIpGeoLocation()
      }
      return ipGeoLocation?.split(',').map((v: string) => parseFloat(v)) || null
    },
    { cacheTime: Infinity }
  )
}
